import { createBidCard, getBidCards, resetBidCard, updateBidCard } from '../../../services/bid-cards'

export default {
  getBidCards ({ commit }) {
    return new Promise((resolve, reject) => {
      getBidCards()
        .then(response => {
          const bidCards = response.data
          commit('setBidCards', { bidCards })
          resolve(bidCards)
        })
        .catch(reject)
    })
  },

  createBidCard ({ commit }) {
    return new Promise((resolve, reject) => {
      createBidCard()
        .then(response => {
          const bidCard = response.data
          commit('appendBidCard', { bidCard })
          resolve(bidCard)
        })
        .catch(reject)
    })
  },

  updateBidCard ({ commit }, { id, bidCard }) {
    return new Promise((resolve, reject) => {
      updateBidCard(id, bidCard)
        .then(response => {
          const bidCard = response.data
          commit('updateBidCard', { id, bidCard })
          resolve(bidCard)
        })
        .catch(reject)
    })
  },

  resetBidCard ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      resetBidCard(id)
        .then(response => {
          const bidCard = response.data
          commit('resetBidCard', { id, bidCard })
          commit('clearSelectedBidCard')
          resolve(bidCard)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-cards/actions.js